<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />
    <b-row>
      <b-col v-for="provider in finalProviders" :key="provider.code" xs="12" md="6" xl="4">
        <div class="card h-100">
          <div class="card-body p-5 d-flex flex-column">
            <img :src="provider.icon_url" class="mc-integration__icon mb-2" alt="provider_icon" />
            <p class="mc-integration__brand-name my-2">
              {{ provider.name }}
            </p>
            <p class="p-2 mt-2 mc-integration__badge align-self-start">
              {{ provider.group }}
            </p>
            <p class="mc-integration__description flex-grow-1">
              {{ provider.description }}
            </p>
            <McButton
              text=""
              :variant="provider.is_integrated ? `secondary` : `primary`"
              icon="icon-outline_checkmark"
              :block="true"
              :class="
                provider.is_integrated
                  ? 'mc-integration__btn-connected'
                  : 'mc-integration__btn-disconnected'
              "
              @click="connect(provider)"
            />
          </div>
        </div>
      </b-col>
    </b-row>
    <ModalBusinessData @get-list="getList()" />
  </Layout>
</template>

<script>
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButton from '@/components/McButton'
import * as Integration from '@/services/rest-api/lib/setting/integration'
import providers from './lib/constants/providers'
import { errorMessage } from '@/helpers/errorHandler'
import errorMessageList from './lib/constants/error-message-mapping'
import ModalBusinessData from './lib/components/ModalBusinessData'
import { mapGetters } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader,
    McButton,
    ModalBusinessData,
  },
  data() {
    return {
      providers,
      finalProviders: [],
      businessData: [],
      privileges: ['create', 'read', 'update', 'delete'],
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    title() {
      return this.$t('setting.homePage.integration')
    },
    subTitle() {
      return this.$t('setting.homePage.textIntegration')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.list.deliverySetting.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.homePage.integration'),
        },
      ]
    },
  },
  async created() {
    const integrationAccount = localStorage.getItem('integrationAccount')
    const provider = this.providers.find((v) => v.code === integrationAccount)
    if (!integrationAccount) await this.getList()
    if (!provider) return

    const payload = {
      redirect_url: window.location.origin + window.location.pathname,
    }
    payload[provider.property] = this.$route.query.code
    const connect = await provider.connect(payload)
    this.getList()

    if (connect.errors) {
      for (let [key, value] of Object.entries(connect.errors)) {
        if (errorMessageList[key][value[0]]) {
          this.$mcToast.error(errorMessage(errorMessageList[key][value[0]]))
        }
      }
      this.$router.replace({ name: 'Integration' }).catch(() => {})
      return
    }
    localStorage.setItem('integrationAccount', '')
    this.$router.replace({ name: 'Integration' }).catch(() => {})
    this.$bvModal.show('mc-modal-business-data')
  },
  methods: {
    async getList() {
      const payload = { redirect_url: window.location.origin + window.location.pathname }
      const { providers } = await Integration.get(payload)
      if (providers) {
        providers.map((v) => {
          const provider = this.providers.find((provider) => provider.code === v.code)
          if (provider) {
            v.description = provider.description
            v.group = provider.group
            v.icon_url = provider.icon_url
          }
          return v
        })
        this.finalProviders = providers
      }
    },
    async connect(provider) {
      // CHECK SCOPES
      const scopes = []
      for (let i = 0; i < this.privileges.length; i++) {
        scopes.push(`tms-integration-${provider.code.toLowerCase()}:${this.privileges[i]}`)
      }

      if (!this.hasAccess(scopes)) {
        this.$mcToast.warning(
          'Subscription tidak ditemukan. Silahkan hubungi Sales anda untuk mempelajari lebih lanjut.'
        )
        return
      }

      // DISCONNECT
      if (provider.is_integrated) {
        this.disconnect(provider)
        return
      }

      // CONNECT
      if (provider.action === 'CONNECT_BUSINESS_DATA') {
        this.$bvModal.show('mc-modal-business-data')
        return
      }
      localStorage.setItem('integrationAccount', provider.code)
      window.open(provider.redirect_url, '_self')
    },
    async disconnect(item) {
      const provider = this.providers.find((v) => v.code === item.code)
      if (!provider) return
      const disconnect = await provider.disconnect()
      if (disconnect.errors) {
        for (let [key, value] of Object.entries(disconnect.errors)) {
          if (errorMessageList[key][value[0]]) {
            this.$mcToast.error(errorMessage(errorMessageList[key][value[0]]))
          }
        }
        return
      }
      this.$mcToast.success('ACCURATE berhasil dinonaktifkan')
      this.getList()
    },
  },
}
</script>

<style lang="scss">
.button-center {
  justify-content: center;
  text-align: center;
}
.mc-integration {
  &__icon {
    max-width: 64px;
  }

  &__brand-name {
    font-size: 16px;
  }

  &__badge {
    background-color: $cyan-100;
    border-radius: 6px;
    color: $cyan-500;
  }

  &__description {
    line-height: 28px;
  }

  &__btn-connected .mc-button {
    @extend .button-center;
    &::after {
      content: 'Terhubung';
    }
    &:hover {
      color: $red !important;
      background: $white !important;
      border-color: $red !important;
      &::after {
        content: 'Non-Aktifkan';
      }
      .mc-icon::before {
        color: $red !important;
      }
    }
  }
  &__btn-disconnected .mc-button {
    @extend .button-center;
    &::after {
      content: 'Hubungkan';
    }
  }
}
</style>
